import { Button, Grid, useTheme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { DatadogErrorTracker, FeatureAreas } from '../../../utils/DatadogErrorTracker';
import Chevron from '../Chevron';

const PhotoAccordion = (props: any) => {
  const [expanded, setExpanded] = useState(props.expanded);
  const theme = useTheme();

  useEffect(() => {
    setExpanded(props.expanded);
  }, [props.expanded]);

  // Track when accordion is expanded
  useEffect(() => {
    if (expanded) {
      DatadogErrorTracker.setFeatureContext(FeatureAreas.POST_FNOL_PHOTOS, {
        activeAccordion: 'photos',
      });

      DatadogErrorTracker.trackAction('photo-accordion-expanded', {
        accordionTitle: props.title,
      });
    } else {
      DatadogErrorTracker.clearFeatureContext(['activeAccordion']);
    }
  }, [expanded, props.title]);

  const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  function toggleAccordion() {
    setExpanded(!expanded);
  }

  const ChevronButton = () => (
    <Button
      disableRipple
      onClick={toggleAccordion}
      sx={{
        ...theme.custom.styles.accordionHeaderButtonStyle,
        minWidth: 'auto',
      }}
    >
      <Chevron
        isActive={expanded}
        fill={theme.custom.colors.accordionChevronColor}
        sx={{ padding: '0rem' }}
        height={theme.custom.styles.chevronHeight}
        width={theme.custom.styles.chevronWidth}
      />
    </Button>
  );

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange}
      slotProps={{ transition: { timeout: 600, unmountOnExit: true } }}
      sx={{ border: 'none', boxShadow: 'none', paddingLeft: '.5rem' }}
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{ paddingLeft: '8px', paddingRight: '0px' }}
      >
        <Grid container alignItems="center" justifyContent="space-between" spacing={1}>
          {theme.custom.styles.chevronFirst ? (
            <>
              <Grid item>
                <ChevronButton />
              </Grid>
              <Grid item xs>
                <Typography sx={theme.custom.styles.accordionRowHeader}>{props.title}</Typography>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs>
                <Typography sx={theme.custom.styles.accordionRowHeader}>{props.title}</Typography>
              </Grid>
              <Grid item>
                <ChevronButton />
              </Grid>
            </>
          )}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>{props.component}</AccordionDetails>
    </Accordion>
  );
};

export default PhotoAccordion;
